import styled from "styled-components";

export const VideoWrapper = styled.div`
  width: 100%;
  box-shadow: ${({ theme }) => theme.boxShadow};
`;
export const VideoPoster = styled.img`
  width: 100%;
  display: block;
`;
